import { useEffect } from 'react';
import { Select, Space, Typography } from 'antd';
import { ClockCircleOutlined, CalendarOutlined } from '@ant-design/icons';
import { useData } from '../../../contexts/DataContext';
import { useSelection } from '../../../contexts/SelectionContext';
import './styles.css';

const { Text } = Typography;

// Day type labels in Italian
const dayTypeLabels = {
  Feriali: 'Feriali (Giorni lavorativi)',
  Sabato: 'Sabato',
  Festivi: 'Festivi (Domenica e festivi)',
};

const DateTimeSelector = ({ viewId = 1 }) => {
  const { dayTypes, timeSlots, loading } = useData();
  const { getViewSelection } = useSelection();

  const { dayType, timeSlot, setDayType, setTimeSlot } = getViewSelection(viewId);

  // Auto-select first day type and time slot when data loads
  useEffect(() => {
    if (!loading && dayTypes.length > 0 && !dayType) {
      setDayType(dayTypes[0]); // Will be "Feriali"
    }
  }, [loading, dayTypes, dayType, setDayType]);

  useEffect(() => {
    if (!loading && timeSlots.length > 0 && dayType && !timeSlot) {
      const defaultSlot = timeSlots.find(s => s !== 'Intera giornata') || timeSlots[0];
      setTimeSlot(defaultSlot);
    }
  }, [loading, timeSlots, dayType, timeSlot, setTimeSlot]);

  // Generate day type options
  const dayTypeOptions = dayTypes.map((type) => ({
    value: type,
    label: dayTypeLabels[type] || type,
  }));

  // Generate time slot options
  const timeSlotOptions = timeSlots.map((slot) => ({
    value: slot,
    label: slot === 'Intera giornata' ? 'Tutto il giorno' : slot,
  }));

  return (
    <div className="datetime-selector">
      <Space direction="vertical" size="small" style={{ width: '100%' }}>
        <div className="selector-group">
          <Text className="selector-label">
            <CalendarOutlined /> Tipo Giorno
          </Text>
          <Select
            value={dayType}
            onChange={setDayType}
            options={dayTypeOptions}
            placeholder="Seleziona tipo giorno"
            loading={loading}
            className="datetime-select"
            popupClassName="datetime-dropdown"
            style={{ width: '100%' }}
          />
        </div>
        <div className="selector-group">
          <Text className="selector-label">
            <ClockCircleOutlined /> Ora
          </Text>
          <Select
            value={timeSlot}
            onChange={setTimeSlot}
            options={timeSlotOptions}
            placeholder="Seleziona ora"
            loading={loading}
            className="datetime-select"
            popupClassName="datetime-dropdown"
            style={{ width: '100%' }}
          />
        </div>
      </Space>
    </div>
  );
};

export default DateTimeSelector;
